<div class="header">
  <h3>{{'MENU.RESOLVE_ERROR' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row align-items-center">
    <div class="col-md-6 form-group">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="customerCode"
          [options]="customercode"
          [(ngModel)]="selectedCustomercode"
          [autoDisplayFirst]="false" placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}" [style]="{'z-index': 3}"
          filter="true">
        </p-dropdown>
        <label for="customerCode">{{'FILTER.CUSTOMER-CODE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-6  form-group">
      <div class="dropdown-label-group">

        <p-multiSelect
          class="dv-dropdown "
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [panelStyle]="{minWidth: '520px'}"
          [defaultLabel]="defaultLabel"
        >
        </p-multiSelect>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="documentNumber"
               placeholder="{{ 'FILTER.DOCUMENT-NUMBER' | translate }}">
        <label for="month">{{ "FILTER.DOCUMENT-NUMBER" | translate }}</label>
      </div>
    </div>

    <div class="col-md-6  form-group">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); sentdate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1 mt-3">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="optionChanged()"
  >
  </app-custom-pagination>
  <div class=" m-t-30">
    <p-table class="scrollable" [value]="errors" dataKey="value" *ngIf="!loading">
      <ng-template pTemplate="header">
        <tr class="text-center">
          <th scope="col" width="10%">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th scope="col" width="20%">{{'NORMAL.CUS-CODE' | translate}}</th>
          <th scope="col" width="15%">{{'FILTER.DOCUMENT-TYPE' | translate }}</th>
          <th scope="col" width="15%">{{'FILTER.DOCUMENT-NUMBER' | translate }}</th>
          <th scope="col" width="30%">{{'DATA.DELIVERY-ADD' | translate}}</th>
          <th scope="col" width="15%">{{'FILTER.DATE-OF-ISSUE' | translate}}</th>
          <th scope="col" width="15%">{{'RESOLVE.REASON' | translate}}</th>
          <th scope="col" width="15%">{{'RESOLVE.RESOLVE' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">

        <tr class="ui-widget-header text-center" >
          <td> {{ index + 1+ ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.customer_code}}</td>
          <td>{{data.document_type_display}}</td>
          <td>{{data.document_number}}</td>
          <td class="text-left">{{data.delivery_address}}</td>
          <td>{{ data.document_date | date:"dd/MM/yyyy"}}</td>
          <td *ngIf="data.reason == 'unknown'" style="color: red">
           <span>{{'RESOLVE.UNKNOWN' | translate}}</span>
          </td>
          <td *ngIf="data.reason == 'customer code not match'" style="color: red">
           <span>{{'RESOLVE.CUSTOMER-NOT-MATCH' | translate}}</span>
          </td>
          <td *ngIf="data.reason == 'address not match'" style="color: red">
           {{'RESOLVE.NOT-MATCH' | translate}}
          </td>
          <td *ngIf="data.reason !=='unknown' ">
            <button (click)="resolveError($event, popup, data)" type="button"
                  class=" text-center btn btn-primary">{{'RESOLVE.RESOLVE' | translate}}
            </button>
          </td>
          <td *ngIf="data.reason =='unknown'">
            <button (click)="resolveError($event, popup, data)" type="button"
                  disabled class=" text-center btn btn-primary">{{'RESOLVE.RESOLVE' | translate}}
            </button>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>


<ng-template #popup let-modal>
  <div class="modal-header">
    <h3>{{'FILTER.CUSTOMER-CODE' | translate}}:{{modalData.customer_code}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model" >
              <div class="row bg-model" *ngIf="!loading_main">
                <div class="col-12 text-center bg-model" *ngIf="!alerterror">
                  <h5>Original Address</h5>
                  <div class="form-label-group box-parent">
                   <span>
                     {{modalData.delivery_address}}
                   </span>
                    </div><br>
                  <h5 *ngIf="disable==true">New Address</h5>
                    <div  *ngIf="disable==true" class="form-label-group box-parent">
                        <span *ngIf="disable==true">
                           {{delivery_address}}
                        </span>
                  </div><br>
                  <div class="col-md-12 form-group" *ngIf="CountAddress">
                    <div class="dropdown-label-group">
                      <p-dropdown
                        class="dv-dropdown"
                        selectId="customerCode"
                        [options]="commonAddress"
                        [(ngModel)]="selsetecdCommon"
                        [autoDisplayFirst]="false" placeholder="{{'DATA.DELIVERY-ADD' | translate}}" [style]="{'z-index': 3}"
                        filter="true"
                        (onChange)="changeAdd()"
                      >
                      </p-dropdown>
                      <label for="customerCode">{{'DATA.DELIVERY-ADD' | translate}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center bg-model" *ngIf="alerterror">
                 <p>
                <ngb-alert type="danger" [dismissible]="false">
                  {{ checkErrorCode() | translate }}
                  <br>
                  <strong>Error:</strong>{{alerterror.error}}
<!--                  <br>-->
                </ngb-alert>
                </p>
                </div>
              </div>
      <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide redius-border" (click)="revertBack()">{{'COMMON.CLOSE' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0" >
      <button *ngIf="!alerterror"  type="button" (click)="save_new_customer()" class="btn btn-dv btn-wide redius-border"> {{'TEXT.SAVE' | translate}}
      </button>
    </div>
  </div>
<!--  </div>-->
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error.component.html